// For role="checkbox" and role="radio" divs, which get no native focus style. accent-default is
// 5.5:1 against the dark canvas, pink-700 7.1:1 against white; pink-700 only where the surface
// itself turns white in light mode, since it is under 3:1 on the tables that stay dark.
export const controlFocusRing = (supportsLightTheme: boolean): string =>
  `outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent-default ${
    supportsLightTheme ? 'light:focus-visible:outline-pink-700' : ''
  }`;
